// SPDX-License-Identifier: LicenseRef-MMS-WIRE
// Copyright (c) 2016-2026 Metal Management Solutions (Pty) Ltd

import {ChangeDetectionStrategy, Component, inject, ViewEncapsulation} from '@angular/core';
import {MatDialog} from '@angular/material/dialog';

import {openAboutWireDialog} from '../about-wire-dialog/about-wire-dialog.component';
import {copyrightNotice, GTC_PATH, LICENCE_PATH} from '../../shared/legal';

@Component({
    selector: 'src-legal-footer',
    templateUrl: './legal-footer.component.html',
    styleUrls: ['./legal-footer.component.scss'],
    encapsulation: ViewEncapsulation.None,
    changeDetection: ChangeDetectionStrategy.OnPush
})
export class LegalFooterComponent {
    private readonly dialog = inject(MatDialog);

    protected readonly notice = copyrightNotice();
    protected readonly gtcPath = GTC_PATH;
    protected readonly licencePath = LICENCE_PATH;

    protected openAbout(): void {
        openAboutWireDialog(this.dialog);
    }
}
